import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'

const firebaseConfig = {
  apiKey: "AIzaSyDcpPeARB4z5_g5ErIu85-FDfDeOWHm65M",
  authDomain: "storyshot-b572e.firebaseapp.com",
  projectId: "storyshot-b572e",
  storageBucket: "storyshot-b572e.firebasestorage.app",
  messagingSenderId: "55289891028",
  appId: "1:55289891028:web:90b4b71680146622c2d341",
  measurementId: "G-GW1J6M4MPS"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export const functions = getFunctions(app)

export default app 